import { EntityTemplateVariables } from '@tools/interfaces/template';

export const templateUser: EntityTemplateVariables = {
  fields: [
    {
      label: 'templates.global.user_name.label',
      contentValue: `{{ user.name }}`,
      description: 'templates.global.user_name.description',
    },
    {
      label: 'templates.global.user_email.label',
      contentValue: `{{ user.email }}`,
      description: 'templates.global.user_name.description',
    },
  ],
  related: [],
  relatedInLoop: [],
};
